﻿const collapsibleFilterCount = 5;

function collapsibleClicked(titleContainer, filters) {
    // possible states: collapsed | expanded
    let icon = null;

    const collapsibleState = titleContainer.attr('data-collapsible-state');
    if (collapsibleState === 'collapsed') {
        // 1. change state from collapsed => expanded
        // 2. show down arrow (filter expanded)
        // 3. show all hidden filters

        titleContainer.attr('data-collapsible-state', 'expanded');  // change from collapsed to expanded
        titleContainer.find('.icon')
            .removeClass('fa-caret-right')
            .addClass('fa-caret-down')
        ;   // change from caret-right => caret-down (fa-caret-down icon)

        filters.each(function () {  // show filters
            //$(this).show();
          	$(this).slideDown();
        });
        return true;
    }
    else if (collapsibleState === "expanded") {
        // 1. change state from expanded => collapsed
        // 2. show right arrow (filter collapsed)
        // 3. hide filters

        titleContainer.attr('data-collapsible-state', 'collapsed'); // change from expanded to collapsed
        titleContainer.find('.icon')
            .removeClass('fa-caret-down')
            .addClass('fa-caret-right')
        ;   // change from caret-down => caret-right (fa-caret-right icon)

        filters.each(function (index) { // hide filters
            if (index >= collapsibleFilterCount) {
                //$(this).hide();
              	$(this).slideUp();
            }
        });
        return true;
    }
    else {
        return false;
    }
}

$(document).ready(function () {
    const filterSidebar = $('#CollectionFiltersForm');
    filterSidebar.children('.filterBox').each(function () {
        const filterBox = $(this);
        const titleContainer = filterBox.find('.widget-title');
        const filters = filterBox.find('.widget-content li');

        if (filters.length > collapsibleFilterCount) {
            const icon = $('<i></i>')
            	.addClass('fa-solid icon')
            	.css('text-align', 'center')
            ;
            titleContainer
                .attr('data-collapsible-state', 'expanded') // setting 'data-collapsible-state'
                .css('cursor', 'pointer')                   // change cursor so that the user knows it's clickable
            ;
            titleContainer.children('span')
                .append(icon);          // add icon to indicate the current state

            collapsibleClicked(titleContainer, filters);
        }
    });
    filterSidebar.on('click', '.widget-title[data-collapsible-state]', function () {
        const titleContainer = $(this);
        const filterBox = titleContainer.closest('.filterBox');
        const filters = filterBox.find('.widget-content li');

        return collapsibleClicked(titleContainer, filters);
    });
});